import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { useAllOrders } from "../../../../../api/orders/orders";
import { useLoader } from "../../../../../utils/LoaderContext";

const ORDERS_PER_PAGE = 20;

const CodSection = () => {
  const [searchText, setSearchText] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const { setLoading } = useLoader();

  const {
    data: allOrdersData,
    isLoading,
    isError,
  } = useAllOrders({
    currentPage,
    ORDERS_PER_PAGE,
    PaymentType: "cod", // Only COD
    search: searchQuery,
  });

  // Debounce Search
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearchQuery(searchText.trim());
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(delay);
  }, [searchText]);

  const orders = allOrdersData?.orders || [];

  // ⭐ FILTER AGAIN ON FRONTEND (important fix)
  const filteredOrders = orders.filter(
    (order) => order.PaymentType?.toLowerCase() === "cod"
  );

  const totalPages = allOrdersData?.totalPages || 1;

  if (isError) return <p className="text-red-600">Error fetching COD orders</p>;

  return (
    <div className="w-full mt-6">
      {/* Search */}
      <div className="mb-4">
        <Input
          className="w-80"
          placeholder="Search by AWB, Order Number or Name"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto hide-scrollbar">
        <table className="min-w-[1200px] w-full table-auto border border-gray-200">
          <thead className="bg-gray-100 text-left text-sm font-semibold text-gray-700">
            <tr>
              <th className="p-3">Order Date</th>
              <th className="p-3">Order Number / Status</th>
              <th className="p-3">Payment</th>
              <th className="p-3">Products</th>
              <th className="p-3">Customer / Contact</th>
              <th className="p-3">Address</th>
              <th className="p-3">Courier Details</th>
              <th className="p-3">Charges</th>
            </tr>
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={9} className="text-center py-6 text-gray-500">
                  Loading COD orders...
                </td>
              </tr>
            ) : filteredOrders.length > 0 ? (
              filteredOrders.map((order, index) => (
                <tr key={order._id || index} className="hover:bg-gray-50">
                  <td className="p-4">
                    {new Date(order.createdAt).toLocaleDateString()}
                  </td>

                  <td className="p-4">
                    <div className="font-medium text-blue-600">
                      {order.OrderNumber}
                    </div>
                    <div className="text-xs mt-1 bg-yellow-100 text-yellow-700 px-2 py-1 rounded">
                      {order.shippingStatusText}
                    </div>
                  </td>

                  <td className="p-4">
                    ₹{order.InvoiceAmount}
                    <div className="text-xs mt-1 bg-yellow-100 text-yellow-700 px-2 py-1 rounded">
                      {order.PaymentType}
                    </div>
                  </td>

                  <td className="p-4">
                    {order.ProductDetails?.map((prod, i) => (
                      <p key={i}>{prod.name}</p>
                    ))}
                  </td>

                  <td className="p-4">
                    <p>{order.CustomerName}</p>
                    <p>{order.BillingAddress?.Contact}</p>
                  </td>

                  <td className="p-4">
                    <p>{order.BillingAddress?.City}</p>
                    <p>{order.BillingAddress?.State}</p>
                    <p>{order.BillingAddress?.Pincode}</p>
                  </td>

                  <td className="p-4">
                    <p>{order.awbNumber || "-"}</p>
                    <p>{order.courier || "-"}</p>
                  </td>

                  <td className="p-4">
                    <p> ₹{order.ShippingCharge}</p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="text-center py-6 text-gray-400">
                  No COD orders found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-between items-center mt-6 text-sm">
          <p>
            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
          </p>
          <div className="space-x-2">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="px-4 py-2 border rounded"
            >
              Previous
            </button>
            <button
              onClick={() => setCurrentPage((prev) => prev + 1)}
              className="px-4 py-2 border rounded"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CodSection;
